import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'   // Use 'smooth' if you prefer animation
    });
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;